import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  "data-testid": "transfer-order-receiving-instructions-modal-close-btn",
                  onClick: _ctx.closeModal
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "icon-only",
                      icon: _ctx.closeOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { "data-testid": "transfer-order-receiving-instructions-modal-title" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.translate("What's next")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { "data-testid": "transfer-order-receiving-instructions-modal-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_list, { "data-testid": "transfer-order-receiving-instructions-list" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, {
              "data-testid": "transfer-order-receiving-instructions-open-items-section",
              lines: "full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.translate("out of items open", { openItems: _ctx.openItems, items: _ctx.items })), 1),
                    _createElementVNode("p", {
                      innerHTML: _ctx.translate('Submit a quantity on all open items to receive and close them. Enter 0 quantity for items you didn’t receive complete quantities for.', { space: '<br/>' })
                    }, null, 8, _hoisted_1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.translate("Use the open tab to view outstanding items.")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, {
              "data-testid": "transfer-order-receiving-instructions-complete-section",
              lines: "none"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.translate("Receive and complete")), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.translate("Once all quantities are submitted, click 'Receive and complete' at the bottom of the page. Review any discrepancies and close this transfer order.")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}